import { render, staticRenderFns } from "./DamCompareWaterMobile.vue?vue&type=template&id=6d6d485d&scoped=true"
import script from "./DamCompareWaterMobile.vue?vue&type=script&lang=ts"
export * from "./DamCompareWaterMobile.vue?vue&type=script&lang=ts"
import style0 from "./DamCompareWaterMobile.vue?vue&type=style&index=0&id=6d6d485d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6d485d",
  null
  
)

export default component.exports